export enum ModalActionType {
  OPEN = 'OPEN_MODAL',
  CLOSE = 'CLOSE_MODAL',
  SET_CURRENT_MODAL = 'SET_CURRENT_MODAL',
}
